import { Manifestation } from '@skinsoft/types'
import { dbCacheDown } from '../dexie/cache-down'
import { STATS_KEYS } from '../dexie/stats-keys'
import { OfflineDataFetcher } from '@skinsoft/offline'

export class ManifestationOfflineDataFetcher extends OfflineDataFetcher<Manifestation>{

    constructor() {
        super(dbCacheDown.manifestation, STATS_KEYS.manifestation)
    }

    /*public fetchWemiFromId(id: string): Observable<any> {
        return super.fetchOneFromId(id)
    }*/

    protected idMatcher(entity: any, id: string) {
        if (entity.manifestation) {
            return entity.manifestation.id === id;
        }
        return false;
    }

}